"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMitekBase = void 0;
const React = __importStar(require("react"));
const web_ui_features_1 = require("@gruposantander/web-ui-features");
const types_1 = require("../../mobileConnector/types");
const useMitekBase = (mobileConnector) => {
    const INITIAL_STATE = {
        isRequestingCamera: false,
        isError: false,
        isSuccess: false,
    };
    const [messageStatus, setMessageStatus] = React.useState(INITIAL_STATE);
    const [isCameraEnabled, setCameraEnabled] = React.useState(false);
    const isAndroid = (0, web_ui_features_1.isAndroidWebView)();
    const handleResponse = (response) => {
        const { status } = response;
        if (status === types_1.CameraAccessStatus.ACCEPTED) {
            setMessageStatus({ ...INITIAL_STATE, isRequestingCamera: false, isSuccess: true });
            setCameraEnabled(true);
        }
        else if (status === types_1.CameraAccessStatus.REJECTED || status === types_1.CameraAccessStatus.PERMANENT_REJECTED) {
            setMessageStatus({ ...INITIAL_STATE, isRequestingCamera: false, isError: true });
            setCameraEnabled(false);
        }
    };
    React.useEffect(() => {
        async function sendMessageToApp() {
            try {
                setMessageStatus({ ...INITIAL_STATE, isRequestingCamera: true });
                const data = (await mobileConnector.requestCameraAccess());
                const response = await JSON.parse(data);
                handleResponse(response);
            }
            catch (err) {
                setMessageStatus({ ...INITIAL_STATE, isRequestingCamera: false, isError: true });
                console.error('Error while requesting camera access', err);
            }
        }
        isAndroid ? sendMessageToApp() : setCameraEnabled(true);
    }, []);
    return { isError: messageStatus.isError, isCameraEnabled };
};
exports.useMitekBase = useMitekBase;
//# sourceMappingURL=useMitekBase.js.map